<template>
  <div class="modal-container">
    <div class="add-box clearfix">
      <table-header
          @add="insertEvent"
          @remove="removeEvent"
          @copy="paste"
      ></table-header>
      <vxe-table
          border
          show-overflow
          show-footer
          ref="xTable"
          class="table-style"
          max-height="450"
          :auto-resize="true"
          :data="tableData"
          :edit-rules="isExport ? importRules : formRules"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
          :footer-method="footerMethod"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
          @scroll="clearV"
      >
        <vxe-table-column
            type="checkbox"
            align="center"
            width="50"
        ></vxe-table-column>
        <vxe-table-column field="no" title="序号" width="60"></vxe-table-column>
        <vxe-table-column field="chooseOrder" title="关联订单" width="137">
          <template v-slot="{ row, $rowIndex }">
            <a
                class="sel-link"
                v-if="isOrder"
                @click="openLink({ i: $rowIndex, data: tableData })"
                target="_black"
                style="cursor: pointer"
            >
              {{
              row.ordersSellerLv2Num
              ? row.ordersSellerLv2Num
              : row.ordersSellerNum
              ? row.ordersSellerNum
              : "选择关联订单"
              }}
            </a>
            <span class="sel-link" v-if="!isOrder">
              {{
                row.ordersSellerLv2Num
                  ? row.ordersSellerLv2Num
                  : row.ordersSellerNum
                  ? row.ordersSellerNum
                  : "选择关联订单"
              }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="compName" title="平台企业" width="150">
          <template v-slot="{ row }">
            <platform-corp
                v-if="!row.ordersSellerLv2Num && !row.ordersSellerNum"
                :row="row"
                :field="'compName'"
                :placeholder="'请选择平台企业'"
            ></platform-corp>
            <span
                v-if="row.ordersSellerLv2Num || row.ordersSellerNum"
                class="sel-link"
            >{{ row.compName }}</span
            >
          </template>
        </vxe-table-column>
        <vxe-table-column field="logisticsCode" title="物流单号" width="137">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.logisticsCode"
                placeholder="选填"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="isTop" title="状态" width="120">
          <template v-slot="scope">
            <vxe-select v-model="scope.row.isTop" transfer placeholder="请选择">
              <vxe-option v-for="(item,index) in isTopTypeOptions" :key="index" :value="item.value"
                          :label="item.label" @change="clearV"></vxe-option>
            </vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsType" title="货物类型" width="140">
          <template v-slot="scope">
            <vxe-select
                v-model="scope.row.goodsType"
                placeholder="请选择"
                :options="goodsTypeOptions"
                @change="clearV"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="170">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.goodsName"
                placeholder="必填"
                @blur="clearV"
                @input="$refs.xTable.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRule" title="规格" width="110">
          <template v-slot="{ row }">
            <vxe-input v-model="row.goodsRule" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="counts" title="装货数量" width="116">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.counts"
                placeholder="必填"
                @blur="clearV"
                v-on:input="countDeviate(scope.row)"
                type="number"
                @input="$refs.xTable.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="realCount" title="实际数量" width="116">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.realCount"
                placeholder="必填"
                @blur="clearV"
                v-on:input="countDeviate(scope.row)"
                type="number"
                @input="$refs.xTable.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="deviate" title="盈亏数量" width="116">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.deviate"
                placeholder="选填"
                type="number"
                @input="$refs.xTable.updateStatus(scope)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsUnit" title="单位" width="70">
          <template v-slot="scope">
            <!-- <vxe-input v-model="scope.row.goodsUnit" placeholder="必填" @blur="clearV"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input> -->
            <vxe-select
                v-model="scope.row.goodsUnit"
                placeholder="请选择"
                :options="unitTypeOptions"
                @change="clearV"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="116">
          <template v-slot="{ row, $rowIndex }">
            <a
                class="sel-link"
                @click="openCarShip({ i: $rowIndex, data: tableData })"
                target="_black"
                style="cursor: pointer"
            >
              {{
              row.carShipNum === null || row.carShipNum === ""
              ? "请选择车船"
              : row.carShipNum
              }}
            </a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="voyage" title="航次号" width="116">
          <template v-slot="{ row }">
            <vxe-input v-model="row.voyage" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column field="deliveryPlace" title="交货地点" width="116">
          <template v-slot="{ row }">
            <vxe-input v-model="row.deliveryPlace" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column> -->
        <!-- <vxe-table-column field="beginPlace" title="起运地" width="116">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.beginPlace" placeholder="必填" @blur="clearV"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column> -->
        <!-- <vxe-table-column field="beginPlaceArea" title="起运地" width="200">
          <template v-slot="{ row }">
            <Cascader
              :data="cityData"
              :load-data="loadData"
              :disabled="row.logisticsType !== 1"
              v-model="row.beginPlaceArea"
              transfer
            ></Cascader>
          </template>
        </vxe-table-column> -->
        <vxe-table-column field="province" title="起运地(省)" width="100">
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
                v-model="row.province"
                :options="cityData"
                @change="loadCity(row.province, $rowIndex, 1)"
                @blur="clearV"
                :disabled="row.logisticsType !== 1"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="city" title="起运地(市)" width="100">
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
                v-model="row.city"
                :options="row.cityOptions"
                @change="loadArea(row.province, row.city, $rowIndex, 1)"
                @blur="clearV"
                :disabled="row.logisticsType !== 1"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="area" title="起运地(区)" width="100">
          <template v-slot="{ row }">
            <vxe-select
                v-model="row.area"
                :options="row.areaOptions"
                @blur="clearV"
                :disabled="row.logisticsType !== 1"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="beginPlaceAddress"
            title="详细地址"
            width="160"
        >
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.beginPlaceAddress"
                placeholder="起运地"
                @focus="clearV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="beginTime" title="起运时间" width="160">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.beginTime"
                placeholder="选择日期"
                :type="row.logisticsType === 2 ? 'date' : 'datetime'"
                transfer
            ></vxe-input>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column field="endPlace" title="到达地" width="116">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.endPlace" placeholder="必填" @blur="clearV"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column> -->
        <!--ship: logisticsType =2 -->
        <!-- <vxe-table-column field="endPlaceArea" title="到达地" width="200">
          <template v-slot="{ row }">
            <Cascader
              :data="cityData"
              :load-data="loadData"
              :disabled="row.logisticsType !== 1"
              v-model="row.endPlaceArea"
              transfer
            ></Cascader>
          </template>
        </vxe-table-column> -->
        <vxe-table-column field="endProvince" title="到达地(省)" width="100">
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
                v-model="row.endProvince"
                :options="cityData"
                @change="loadCity(row.endProvince, $rowIndex, 2)"
                @blur="clearV"
                :disabled="row.logisticsType !== 1"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endCity" title="到达地(市)" width="100">
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
                v-model="row.endCity"
                :options="row.endCityOptions"
                @change="loadArea(row.endProvince, row.endCity, $rowIndex, 2)"
                @blur="clearV"
                :disabled="row.logisticsType !== 1"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endArea" title="到达地(区)" width="100">
          <template v-slot="{ row }">
            <vxe-select
                v-model="row.endArea"
                :options="row.endAreaOptions"
                @blur="clearV"
                :disabled="row.logisticsType !== 1"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endPlaceAddress" title="详细地址" width="160">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.endPlaceAddress"
                placeholder="到达地"
                @focus="clearV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endTime" title="到达时间" width="160">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.endTime"
                placeholder="选择日期"
                :type="row.logisticsType === 2 ? 'date' : 'datetime'"
                transfer
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="note" title="备注" width="116">
          <template v-slot="{ row }">
            <vxe-input v-model="row.note" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="fileList" title="上传附件" width="150">
          <template v-slot="{ row }">
            <upload-list
                :row="row"
                :initFileList="row.fileList"
                :view="'packup'"
            ></upload-list>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box">
      <Button status="primary" @click="impotEvent" v-if="isExport"
      >上传导入文件
      </Button
      >
      <Button status="primary" @click="save">提 交</Button>
    </div>
    <vxe-modal
        v-model="orderVisible"
        title="选择订单"
        width="1300"
        height="580"
        resize
        position="center"
    >
      <choose-order
          ref="orderModal"
          @choose="chooseOrder"
          :orderId="orderId"
      ></choose-order>
    </vxe-modal>
    <vxe-modal
        v-model="carShipVisible"
        title="选择车船"
        width="1300"
        height="600"
        resize
        position="center"
    >
      <choose-car-ship
          ref="carShipModal"
          @choose="chooseCarShip"
      ></choose-car-ship>
    </vxe-modal>
    <vxe-modal
        v-model="messageVisible"
        title="消息提示"
        width="600"
        height="350"
        @close="closeMessage"
        position="center"
    >
      <Message ref="messageModal" @close="closeMessage"></Message>
    </vxe-modal>
  </div>
</template>

<script>
  import $C from "@/consts/index";
  import ChooseOrder from "@/components/modal/ChooseRelationOrder";
  import ChooseCarShip from "@/components/modal/ChooseCarShip";
  import $api from "@/apiProvider";
  import XLSX from "xlsx";
  import Message from "@/components/common/Message";
  import {
    getExcelTime,
    showLoading,
    hideLoading,
    isEmpty,
    isNotEmpty
  } from "@/utils/util";
  import UploadList from "@/components/common/UploadList";
  import TableHeader from "../../components/common/TableHeader";
  import PlatformCorp from "@/components/common/PlatformCorp";
  import moment from "moment";

  var appData = require("@/assets/json/zz.json");

  export default {
    props: ["orderId"],
    components: {
      ChooseOrder,
      ChooseCarShip,
      Message,
      UploadList,
      TableHeader,
      PlatformCorp
    },
    data() {
      return {
        formRules: {
          goodsType: [{required: true, message: "请选择货物类型"}],
          goodsName: [{required: true, message: "请输入货名"}],
          counts: [{required: true, message: "请输入装货数量"}],
          realCount: [{required: true, message: "请输入实际数量"}],
          goodsUnit: [{required: true, message: "请输入单位"}],
          carShipNum: [{required: true, message: "请选择车船号"}],
          beginPlaceAddress: [
            {required: true, message: "请输入起运地详细地址"}
          ],
          endPlaceAddress: [{required: true, message: "请输入到达地详细地址"}],
          // beginPlaceArea: [{ validator: this.requireValid }],
          // endPlaceArea: [{ validator: this.requireValid }],
          province: [{validator: this.requireValid}],
          city: [{validator: this.requireValid}],
          area: [{validator: this.requireValid}],
          endProvince: [{validator: this.requireValid}],
          endCity: [{validator: this.requireValid}],
          endArea: [{validator: this.requireValid}],
          beginTime: [{required: true, message: "请选择起运时间"}],
          // endTime: [
          //   {required: true, message: "请选择到达时间"},
          // ],
          compName: [{required: true, message: "请选择所属公司"}]
        },
        importRules: {
          goodsName: [{required: true, message: "请输入货名"}],
          chooseOrder: [{required: true, message: "请选择关联订单"}],
          counts: [{required: true, message: "请输入装货数量"}],
          realCount: [{required: true, message: "请输入实际数量"}],
          goodsUnit: [{required: true, message: "请输入单位"}],
          carShipNum: [{required: true, message: "请选择车船号"}],
          beginPlace: [{required: true, message: "请输入起运地"}],
          endPlace: [{required: true, message: "请输入到达地"}],
          beginTime: [{required: true, message: "请选择起运时间"}],
          // endTime: [
          //   {required: true, message: "请选择到达时间"},
          // ],
          compName: [{required: true, message: "请选择所属公司"}]
        },
        tableData: [
          {
            no: 1,
            beginPlace: null, //起运地
            beginTime: null, //起运时间
            carShipNum: null, //车船号
            counts: null, //数量
            deliveryPlace: null, //交货地址
            deviate: null, //盈亏数量
            endPlace: null, //到达地
            endTime: null, //到达时间
            goodsName: null, //货名
            goodsType: null,
            goodsRule: null, //规格
            goodsUnit: null, //单位
            logisticsCode: null, //物流单号
            logisticsType: null, //运输类型
            note: null, //备注
            ordersSellerId: null, //承运人订单
            ordersSellerLv2Id: null, //二级承运人
            realCount: null, //实际数量
            voyage: null, //航次
            fileList: [],
            fileUuidList: [],
            ordersSellerNum: null,
            compName: null,
            chooseOrder: null,
            beginPlaceArea: [],
            beginPlaceAddress: null,
            endPlaceArea: [],
            endPlaceAddress: null,
            isTop: null,
            province: null,
            city: null,
            area: null,
            endProvince: null,
            endCity: null,
            endArea: null
          }
        ],
        isOrder: true,
        addFileInfo: {},
        orderVisible: false,
        carShipVisible: false,
        fileVisible: false,
        messageVisible: false,
        message: "",
        isExport: false,
        ordersSellerId: null, //承运人订单
        ordersSellerLv2Id: null, //二级承运人
        ordersSellerNum: null,
        ordersSellerLv2Num: null,
        goodsName: null,
        goodsType: null,
        beginPlaceArea: [],
        beginPlaceAddress: null,
        endPlaceArea: [],
        endPlaceAddress: null,
        province: null,
        city: null,
        area: null,
        endProvince: null,
        endCity: null,
        endArea: null,
        goodsRule: null,
        goodsUnit: null,
        carShipNum: null,
        beginPlace: null,
        endPlace: null,
        voyage: null,
        deliveryPlace: null,
        logisticsType: null,
        compName: null,
        isTop: null,
        records: [],
        goodsTypeOptions: [],
        unitTypeOptions: [],
        cityData: [],
        isTopTypeOptions: $C.LogisticsIsTopStatus.options
      };
    },
    methods: {
      getDicDate() {
        this.goodsTypeOptions = [];
        this.unitTypeOptions = [];
        $api.other.getGoodsTypeModel
          .GET({
            params: {
              page: 1,
              rows: 100
            }
          })
          .then(res => {
            res.data.map(item => {
              var obj = {
                label: item.dictText,
                value: item.dictText
              };
              this.goodsTypeOptions.push(obj);
            });
          });
        $api.other.getUnitTypeModel
          .GET({
            params: {
              page: 1,
              rows: 100
            }
          })
          .then(res => {
            res.data.map(item => {
              var obj = {
                label: item.dictText,
                value: item.dictText
              };
              this.unitTypeOptions.push(obj);
            });
          });

        appData.forEach(item => {
          let obj = {
            value: item.label,
            label: item.label
            // children: [],
            // loading: false
          };
          this.cityData.push(obj);
        });
      },
      loadCity(province, index, type, isImpot = false) {
        let tableData = this.$refs.xTable.getTableData().tableData;
        if (!isImpot) {
          if (type === 1) {
            tableData[index].city = "";
            tableData[index].area = "";
          } else {
            tableData[index].endCity = "";
            tableData[index].endArea = "";
          }
        }

        let cityOptions = appData.filter(i => i.label === province);
        // console.log(appData, province, cityOptions, 'cityOptions');

        let isHasChildren = cityOptions[0].children.some(m =>
          isNotEmpty(m.children)
        );
        if (isHasChildren) {
          let arr = cityOptions[0].children.map(i => {
            return {
              label: i.label,
              value: i.label
            };
          });
          type === 1
            ? (tableData[index].cityOptions = arr)
            : (tableData[index].endCityOptions = arr);
        } else {
          let cityArr = [
            {
              label: province,
              value: province
            }
          ];
          type === 1
            ? (tableData[index].cityOptions = cityArr)
            : (tableData[index].endCityOptions = cityArr);
        }
      },
      loadArea(province, city, index, type, isImpot = false) {
        let tableData = this.$refs.xTable.getTableData().tableData;
        if (!isImpot) {
          if (type === 1) {
            tableData[index].area = "";
          } else {
            tableData[index].endArea = "";
          }
        }
        let cityOptions = appData.filter(i => i.label === province);
        let arr = [];
        if (province === city) {
          arr = cityOptions[0].children.map(i => {
            return {
              label: i.label,
              value: i.label
            };
          });
        } else {
          let areaOptions = cityOptions[0].children.filter(i => i.label === city);
          arr = areaOptions[0].children.map(i => {
            return {
              label: i.label,
              value: i.label
            };
          });
        }
        type === 1
          ? (tableData[index].areaOptions = arr)
          : (tableData[index].endAreaOptions = arr);
      },
      loadData(item, callback) {
        const getTree = jsonObj => {
          function toParse(jsonObj) {
            jsonObj.forEach(item => {
              item.value = item.label;
              if (item.children && Array.isArray(item.children)) {
                toParse(item.children);
              }
            });
            return jsonObj;
          }

          return toParse(jsonObj);
        };
        var curCityData = getTree(appData);
        item.loading = true;
        setTimeout(() => {
          let arr = curCityData.filter(i => {
            return i.label === item.value;
          });
          item.children = arr[0].children;
          item.loading = false;
          callback();
        }, 1000);
      },
      async requireValid(e) {
        // if (
        //   e.row.logisticsType === 1 &&
        //   e.column.title == "起运地" &&
        //   isEmpty(e.row.beginPlaceArea)
        // ) {
        //   return Promise.reject(new Error("请选择起运地省市区/县"));
        // }
        // if (
        //   e.row.logisticsType === 1 &&
        //   e.column.title == "到达地" &&
        //   isEmpty(e.row.endPlaceArea)
        // ) {
        //   return Promise.reject(new Error("请选择到达地省市区/县"));
        // }
        if (
          e.row.logisticsType === 1 &&
          e.column.title == "起运地(省)" &&
          isEmpty(e.row.province)
        ) {
          return Promise.reject(new Error("请选择起运地省"));
        }
        if (
          e.row.logisticsType === 1 &&
          e.column.title == "起运地(市)" &&
          isEmpty(e.row.city)
        ) {
          return Promise.reject(new Error("请选择起运地市"));
        }
        if (
          e.row.logisticsType === 1 &&
          e.column.title == "起运地(区)" &&
          isEmpty(e.row.area)
        ) {
          return Promise.reject(new Error("请选择起运地区"));
        }
        if (
          e.row.logisticsType === 1 &&
          e.column.title == "到达地(省)" &&
          isEmpty(e.row.endProvince)
        ) {
          return Promise.reject(new Error("请选择到达地省"));
        }
        if (
          e.row.logisticsType === 1 &&
          e.column.title == "到达地(市)" &&
          isEmpty(e.row.endCity)
        ) {
          return Promise.reject(new Error("请选择到达地市"));
        }
        if (
          e.row.logisticsType === 1 &&
          e.column.title == "到达地(区)" &&
          isEmpty(e.row.endArea)
        ) {
          return Promise.reject(new Error("请选择到达地区"));
        }
      },
      selectChangeEvent({checked, row}) {
        if (checked) {
          this.records.push(row);
        } else {
          let key = this.records.indexOf(row);
          this.records.splice(key, 1);
        }
      },
      selectAllEvent({checked, records}) {
        if (checked) {
          this.records = records;
        } else {
          this.records = [];
        }
      },
      setExport(boolean) {
        this.isExport = boolean;
        this.getDicDate();
      },
      impotEvent() {
        let errTimeLine = "";
        let isHaveErr = false;
        this.$refs.xTable
          .readFile({
            types: ["xls", "xlsx"]
          })
          .then(evnt => {
            showLoading();
            const tableData = [];
            const orderSellerArr = [];
            const orderSellerLv2Arr = [];
            const files = evnt.target.files;
            const fileReader = new FileReader();
            fileReader.onload = async ev => {
              const data = ev.target.result;
              const workbook = XLSX.read(data, {type: "binary"});
              const csvData = XLSX.utils.sheet_to_csv(
                Object.values(workbook.Sheets)[0]
              );
              // 解析数据
              let xlsxData = csvData.split("\n");
              //删除xlsx列名
              xlsxData.splice(0, 1);
              xlsxData.forEach((vRow, index) => {
                if (vRow) {
                  const vCols = vRow.split(",");
                  if (vCols[1]) {
                    orderSellerArr.push(vCols[1]);
                  }
                  if (vCols[2]) {
                    orderSellerLv2Arr.push(vCols[2]);
                  }
                  let beginTime;
                  let endTime;
                  if (vCols[13] === "车辆") {
                    beginTime = moment(vCols[16]).format("YYYY-MM-DD HH:mm:ss");
                    if (vCols[18] && vCols[18] !== '') {
                      endTime = moment(vCols[18]).format("YYYY-MM-DD HH:mm:ss");
                    }
                    if (vCols[16].length < 12 || vCols[18].length < 12) {
                      errTimeLine += `${index + 1},`;
                      isHaveErr = true;
                      if (vCols[16].length < 12) {
                        beginTime = null;
                      }
                      if (vCols[18].length < 12) {
                        endTime = null;
                      }
                    }
                  } else {
                    beginTime = moment(vCols[16]).format("YYYY-MM-DD");
                    if (vCols[18] && vCols[18] !== '') {
                      endTime = moment(vCols[18]).format("YYYY-MM-DD");
                    }
                  }

                  let item = {
                    no: vCols[0],
                    ordersSellerNum: vCols[1],
                    ordersSellerLv2Num: vCols[2],
                    logisticsCode: vCols[3], //物流单号
                    goodsType: vCols[5], //类型
                    goodsName: vCols[6], //货名
                    goodsRule: vCols[7], //规格
                    counts: vCols[8], //装货数量
                    realCount: vCols[9], //实际数量
                    deviate:
                      vCols[10] === ""
                        ? Math.round((vCols[8] - vCols[9]) * 100) / 100
                        : vCols[10], //盈亏数量
                    goodsUnit: vCols[11], //单位
                    carShipNum: vCols[12], //车船号
                    logisticsType: vCols[13], //运输类型
                    voyage: vCols[14], //航次
                    // deliveryPlace: vCols[13], //交货地址
                    // beginPlace: vCols[14], //起运地
                    beginTime, //起运时间
                    // endPlace: vCols[16], //到达地
                    endTime, //到达时间
                    note: vCols[19], //备注
                    ordersSellerId: null, //承运人订单
                    ordersSellerLv2Id: null, //二级承运人
                    fileList: [],
                    fileUuidList: []
                  };

                  if (
                    item.logisticsType !== "车辆" &&
                    item.logisticsType !== "船舶"
                  ) {
                    item.carShipNum = "";
                  } else {
                    item.logisticsType = item.logisticsType === "车辆" ? 1 : 2;
                  }

                  if (vCols[4]) {
                    let obj = $C.LogisticsIsTopStatus.map;
                    let val = vCols[4];
                    for (let key in obj) {
                      if (val === obj[key]) {
                        item.isTop = parseInt(key);
                      }
                    }
                  } else {
                    item.isTop = null;
                  }
                  if (vCols[15]) {
                    if (item.logisticsType === 1) {
                      let beginPlaceArea = [];
                      let address = this.$AddressParse(vCols[15], 0);
                      item.province = address.province;
                      item.city = address.city;
                      item.area = address.area;
                      beginPlaceArea.push(
                        address.province,
                        address.city,
                        address.area
                      );
                      item.beginPlaceArea = beginPlaceArea;
                      // console.log(item.beginPlaceArea);
                      item.beginPlaceAddress = address.detail || address.name;
                    } else {
                      item.beginPlaceArea = [];
                      item.beginPlaceAddress = vCols[15];
                    }
                  }

                  if (vCols[17]) {
                    if (item.logisticsType === 1) {
                      let endPlaceArea = [];
                      let endAddress = this.$AddressParse(vCols[17], 0);
                      item.endProvince = endAddress.province;
                      item.endCity = endAddress.city;
                      item.endArea = endAddress.area;
                      endPlaceArea.push(
                        endAddress.province,
                        endAddress.city,
                        endAddress.area
                      );
                      item.endPlaceArea = endPlaceArea;
                      item.endPlaceAddress = endAddress.detail || endAddress.name;
                    } else {
                      item.endPlaceArea = [];
                      item.endPlaceAddress = vCols[17];
                    }
                  }

                  if (
                    (vCols[1] && vCols[1] !== "") ||
                    (vCols[2] && vCols[2] !== "")
                  ) {
                    item.chooseOrder = 1;
                  }
                  tableData.push(item);
                }
              });
              let res = {status: 1, data: []};
              if (orderSellerArr.length > 0) {
                res = await $api.sellerOrder.post(
                  "queryOrdersSellerSalesInfoList",
                  [...new Set(orderSellerArr)]
                );
              }
              let resLv2 = {status: 1, data: []};
              if (orderSellerLv2Arr.length > 0) {
                resLv2 = await $api.sellerOrder.post(
                  "queryOrdersSellerLv2SalesInfoList",
                  [...new Set(orderSellerLv2Arr)]
                );
              }
              if (res.status === 1 && resLv2.status === 1) {
                let ordersSeller = res.data;
                let ordersSellerLv2 = resLv2.data;
                tableData.map(i => {
                  if (i.ordersSellerLv2Num) {
                    let company = ordersSellerLv2.find(
                      j => j.ordersNum === i.ordersSellerLv2Num
                    );
                    i.compName = company ? company.compName : "";
                  } else if (i.ordersSellerNum) {
                    let company = ordersSeller.find(
                      j => j.ordersNum === i.ordersSellerNum
                    );
                    i.compName = company ? company.compName : "";
                  }
                });
                this.tableData = tableData;
                this.updateFooterEvent();
              } else {
                this.$XModal.alert({
                  message: res.message ? res.message : "接口异常",
                  status: "error"
                });
              }
            };
            fileReader.readAsBinaryString(files[0]);
            setTimeout(() => {
              let arr = this.$refs.xTable.getTableData().tableData;
              arr.forEach((item, index) => {
                if (item.logisticsType === 1) {
                  this.loadCity(item.province, index, 1, true);
                  this.loadCity(item.endProvince, index, 2, true);
                  this.loadArea(item.province, item.city, index, 1, true);
                  this.loadArea(item.endProvince, item.endCity, index, 2, true);
                }
              });
              hideLoading();
              if (isHaveErr) {
                this.$XModal.alert({
                  message: "第" + errTimeLine + "行，日期格式错误",
                  status: "error"
                });
                isHaveErr = false;
              }
            }, 1000);
          });
      },
      countDeviate(row) {
        if (row.counts && row.realCount) {
          let count = row.counts - row.realCount;
          row.deviate = Math.round(count * 100) / 100;
        } else {
          row.deviate = null;
        }
        this.updateFooterEvent();
      },
      async validEvent() {
        let errMap = await this.$refs.xTable.validate().catch(errMap => errMap);
        return errMap ? false : true;
      },
      paste() {
        let records = this.records.sort((a, b) => a.no - b.no);
        if (records.length > 0) {
          records.map(i => {
            let record = Object.assign({}, i);
            record.no = this.$refs.xTable.data.length + 1;
            this.pushIntoTable(record);
          });
        } else {
          this.$XModal.message({
            status: "error",
            message: "请选择需要复制的物流信息！"
          });
        }
      },
      pushIntoTable(record) {
        let {row: newRow} = this.$refs.xTable.insertAt(record, -1);
        this.$refs.xTable.data.push(record);
        this.$refs.xTable.setActiveCell(newRow, "ordersSellerId");
      },
      insertEvent() {
        let record = {
          no: this.$refs.xTable.data.length + 1,
          beginPlace: this.beginPlace, //起运地
          beginTime: null, //起运时间
          carShipNum: this.carShipNum, //车船号
          counts: null, //数量
          deliveryPlace: this.deliveryPlace, //交货地址
          deviate: null, //盈亏数量
          endPlace: this.endPlace, //到达地
          endTime: null, //到达时间
          goodsName: this.goodsName, //货名
          goodsType: this.goodsType,
          goodsRule: this.goodsRule, //规格
          goodsUnit: this.goodsUnit, //单位
          logisticsCode: null, //物流单号
          logisticsType: this.logisticsType, //运输类型
          note: null, //备注
          ordersSellerId: this.ordersSellerId, //承运人订单
          ordersSellerLv2Id: this.ordersSellerLv2Id, //二级承运人
          realCount: null, //实际数量
          voyage: this.voyage, //航次
          fileList: [],
          fileUuidList: [],
          ordersSellerNum: this.ordersSellerNum,
          ordersSellerLv2Num: this.ordersSellerLv2Num,
          compName: this.compName,
          beginPlaceArea: this.beginPlaceArea,
          beginPlaceAddress: this.beginPlaceAddress,
          endPlaceArea: this.endPlaceArea,
          endPlaceAddress: this.endPlaceAddress,
          province: this.province,
          city: this.city,
          area: this.area,
          endProvince: this.endProvince,
          endCity: this.endCity,
          endArea: this.endArea,
          isTop: null
        };
        this.pushIntoTable(record);
      },
      removeEvent() {
        let records = this.records;
        if (records.length > 0) {
          if (this.$refs.xTable.tableData.length > 1) {
            this.$XModal.confirm("您确定要删除选中数据?").then(type => {
              if (type === "confirm") {
                this.clearV();
                records.map(i => {
                  this.$refs.xTable.remove(i);
                  let key = this.$refs.xTable.data.indexOf(i);
                  this.$refs.xTable.data.splice(key, 1);
                });
                this.records = [];
                if (this.isExport === false) {
                  this.$refs.xTable.data.map((j, index) => {
                    j.no = index + 1;
                  });
                }
              }
            });
          } else {
            this.$XModal.alert({
              message: "已经是最后一条了！",
              status: "warning"
            });
          }
        } else {
          this.$XModal.message({
            status: "error",
            message: "请选择需要删除的物流信息！"
          });
        }
      },
      setRelationOrder(order, goods, key) {
        this.isOrder = false;
        if (key === "ordersSellerId") {
          this.tableData[0].ordersSellerNum = order.orderNum;
          this.ordersSellerNum = order.orderNum;
          this.ordersSellerId = order.orderId;
        } else {
          this.tableData[0].ordersSellerLv2Num = order.orderNum;
          this.ordersSellerLv2Num = order.orderNum;
          this.ordersSellerLv2Id = order.orderId;
        }
        this.tableData[0].compName = order.platformCompany;
        this.compName = order.platformCompany;
        this.tableData[0][key] = order.orderId;
        this.tableData[0].goodsName = goods.goodsName;
        this.tableData[0].goodsType = goods.goodsType;
        this.tableData[0].goodsRule = goods.rule;
        this.tableData[0].goodsUnit = goods.unit;
        this.tableData[0].isTop = goods.isTop;
        // this.tableData[0].beginPlace = goods.beginPlace;
        // this.tableData[0].endPlace = goods.endPlace;
        this.tableData[0].beginPlaceArea = goods.beginPlaceArea;
        this.tableData[0].beginPlaceAddress = goods.beginPlaceAddress;
        this.tableData[0].endPlaceArea = goods.endPlaceArea;
        this.tableData[0].endPlaceAddress = goods.endPlaceAddress;

        this.tableData[0].voyage = goods.voyage;
        this.tableData[0].deliveryPlace = goods.deliveryPoints;
        this.tableData[0].logisticsType = goods.transportationType;
        this.tableData[0].chooseOrder = 1;
        this.goodsName = goods.goodsName;
        this.goodsRule = goods.rule;
        this.goodsUnit = goods.unit;
        if (goods.carShipNum) {
          this.carShipNum = goods.carShipNum;
          this.tableData[0].carShipNum = goods.carShipNum;
        }
        if (goods.carShipId) {
          this.carShipId = goods.carShipId;
          this.tableData[0].carShipId = goods.carShipId;
        }
        this.beginPlace = goods.beginPlace;
        this.endPlace = goods.endPlace;
        this.voyage = goods.voyage;
        this.deliveryPlace = goods.deliveryPoints;
        this.logisticsType = goods.transportationType;
        this.beginPlaceArea = goods.beginPlaceArea;
        this.beginPlaceAddress = goods.beginPlaceAddress;
        this.endPlaceArea = goods.endPlaceArea;
        this.endPlaceAddress = goods.endPlaceAddress;
      },
      openCarShip(obj) {
        this.info = obj;
        this.carShipVisible = true;
        this.$refs.carShipModal.init();
      },
      chooseCarShip(row, type) {
        let data = this.info.data;
        let i = this.info.i;
        if (type === "ship") {
          data[i].carShipNum = row.shipName;
          data[i].carShipId = row.id;
          data[i].logisticsType = 2;
        } else {
          data[i].carShipNum = row.carNum;
          data[i].carShipId = row.id;
          data[i].logisticsType = 1;
        }
        this.$refs.carShipModal.close();
        this.carShipVisible = false;
        this.clearV();
      },
      clearV() {
        this.$refs.xTable.clearValidate();
      },
      openLink(obj) {
        if (this.isOrder) {
          this.info = obj;
          this.$refs.orderModal.init();
          this.orderVisible = true;
        }
      },
      async save() {
        let sts = await this.validEvent();
        if (!sts) {
          this.$XModal.message({status: "error", message: "校验不通过！"});
          return;
        }
        // let isCanNotSubmit = false;
        let arr = JSON.parse(JSON.stringify(this.tableData));
        let msg = "";
        let isCanNotSubmit = true;
        arr.map((i, index) => {
          if (i.endTime !== null && i.endTime !== "") {
            if (i.beginTime > i.endTime) {
              msg += `第${index + 1}行，到达时间不能早于到达时间` + "\n";
              isCanNotSubmit = false;
            }
          }
        });
        if (!isCanNotSubmit) {
          this.$refs.messageModal.setMessage(msg);
          this.messageVisible = true;
          return;
        }
        arr.map(i => {
          i.platformCompanyId = i.compNameId;
          i.beginTime = this.$utils.timestamp(i.beginTime);
          if (i.endTime && i.endTime !== '') {
            i.endTime = this.$utils.timestamp(i.endTime);
          }
          if (i.logisticsType == 1) {
            let beginPlaceArea = isNotEmpty(i.area)
              ? i.province === i.city
                ? `${i.city},${i.area}`
                : `${i.province},${i.city},${i.area}`
              : "";
            let beginPlaceArea2 = isNotEmpty(i.area)
              ? i.province === i.city
                ? `${i.city}${i.area}`
                : `${i.province}${i.city}${i.area}`
              : "";

            let endPlaceArea = isNotEmpty(i.endArea)
              ? i.endProvince === i.endCity
                ? `${i.endCity},${i.endArea}`
                : `${i.endProvince},${i.endCity},${i.endArea}`
              : "";
            let endPlaceArea2 = isNotEmpty(i.endArea)
              ? i.endProvince === i.endCity
                ? `${i.endCity}${i.endArea}`
                : `${i.endProvince}${i.endCity}${i.endArea}`
              : "";
            // let beginPlaceArea = isNotEmpty(i.beginPlaceArea)
            //   ? i.beginPlaceArea.join(",")
            //   : "";
            // let beginPlaceArea2 = isNotEmpty(i.beginPlaceArea)
            //   ? i.beginPlaceArea.join("")
            //   : "";
            // let endPlaceArea = isNotEmpty(i.endPlaceArea)
            //   ? i.endPlaceArea.join(",")
            //   : "";
            // let endPlaceArea2 = isNotEmpty(i.endPlaceArea)
            //   ? i.endPlaceArea.join("")
            //   : "";
            let beginPlaceAddress = isNotEmpty(i.beginPlaceAddress)
              ? i.beginPlaceAddress
              : "";
            let endPlaceAddress = isNotEmpty(i.endPlaceAddress)
              ? i.endPlaceAddress
              : "";
            let beginPlace = beginPlaceArea2 + beginPlaceAddress;
            let endPlace = endPlaceArea2 + endPlaceAddress;
            i.beginPlaceArea = beginPlaceArea;
            i.endPlaceArea = endPlaceArea;
            i.beginPlace = beginPlace;
            i.endPlace = endPlace;
            i.beginPlaceAddress = beginPlaceAddress;
            i.endPlaceAddress = endPlaceAddress;
          } else {
            i.beginPlaceArea = "";
            i.endPlaceArea = "";
            i.beginPlace = i.beginPlaceAddress;
            i.endPlace = i.endPlaceAddress;
          }

          if (i.fileList) {
            i.fileList.map(j => {
              i.fileUuidList.push(j.uuid);
            });
          }
        });
        showLoading();
        let res = await $api.logistics.request("createLogistics", arr);
        hideLoading();
        if (res.status === 1) {
          this.$Message.success("提交成功");
          this.close();
          this.$emit("afterSave");
        } else {
          let data = res.data;
          let message = "";
          if (data.length > 0) {
            data.map(i => {
              message =
                message +
                "序号" +
                this.tableData[i.failArrayIndex].no +
                "，" +
                i.failMsg +
                "\n";
            });
            let errorData = [];
            res.data.forEach(failItem => {
              errorData.push(
                Object.assign({}, this.tableData[failItem.failArrayIndex])
              );
            });
            this.tableData = errorData;
          }
          if (message === "") {
            this.$XModal.alert({
              message: "接口异常",
              status: "error"
            });
          } else {
            this.$refs.messageModal.setMessage(message);
            this.messageVisible = true;
          }
        }
      },
      close() {
        this.tableData = [
          {
            no: 1,
            beginPlace: null, //起运地
            beginTime: null, //起运时间
            carShipNum: null, //车船号
            counts: null, //数量
            deliveryPlace: null, //交货地址
            deviate: null, //盈亏数量
            endPlace: null, //到达地
            endTime: null, //到达时间0
            goodsName: null, //货名
            goodsType: null,
            goodsRule: null, //规格
            goodsUnit: null, //单位
            logisticsCode: null, //物流单号
            logisticsType: null, //运输类型
            note: null, //备注
            ordersSellerId: null, //承运人订单
            ordersSellerLv2Id: null, //二级承运人
            ordersSellerNum: null,
            ordersSellerLv2Num: null,
            realCount: null, //实际数量
            voyage: null, //航次
            fileList: [],
            fileUuidList: [],
            compName: null,
            chooseOrder: null,
            beginPlaceArea: [],
            beginPlaceAddress: null,
            endPlaceArea: [],
            endPlaceAddress: null,
            isTop: null,
            province: null,
            city: null,
            area: null,
            endProvince: null,
            endCity: null,
            endArea: null
          }
        ];
        this.ordersSellerId = null; //承运人订单
        this.ordersSellerLv2Id = null; //二级承运人
        this.ordersSellerNum = null;
        this.ordersSellerLv2Num = null;
        this.compName = null;
        this.goodsName = null;
        this.goodsType = null;
        this.goodsRule = null;
        this.goodsUnit = null;
        this.carShipNum = null;
        this.beginPlace = null;
        this.endPlace = null;
        this.voyage = null;
        this.deliveryPlace = null;
        this.logisticsType = null;
        this.beginPlaceArea = [];
        this.beginPlaceAddress = null;
        this.endPlaceArea = [];
        this.endPlaceAddress = null;
        this.isTop = null;
        this.clearV();
        this.records = [];
      },
      closeMessage() {
        this.messageVisible = false;
      },
      chooseOrder(row, key) {
        let data = this.info.data;
        let i = this.info.i;
        data[i].ordersSellerId = null;
        data[i].ordersSellerLv2Id = null;
        data[i].ordersSellerNum = null;
        data[i].ordersSellerLv2Num = null;
        data[i].compName = null;
        data[i][key] = row.id;
        data[i].chooseOrder = 1;
        if (key === "ordersSellerId") {
          data[i].ordersSellerNum = row.sellerOrdersNum;
          data[i].compName = row.buyerName;
        } else {
          data[i].ordersSellerLv2Num = row.sellerOrdersNum;
          data[i].compName = row.platformCompany;
        }
        if (row.goodsRtnVos && row.goodsRtnVos.length > 0) {
          data[i].beginTime = this.$utils.toDateString(
            row.goodsRtnVos[0].beginTime,
            "yyyy-MM-dd"
          );
          data[i].endTime = this.$utils.toDateString(
            row.goodsRtnVos[0].endTime,
            "yyyy-MM-dd"
          );
        } else {
          data[i].beginTime = null;
          data[i].endTime = null;
        }
        if (row.goodsName) {
          data[i].goodsName = row.goodsName;
        } else {
          data[i].goodsName = null;
        }
        if (row.goodsRtnVos && row.goodsRtnVos.length > 0) {
          data[i].goodsType = row.goodsRtnVos[0].goodsType;
          data[i].beginPlaceAddress = row.goodsRtnVos[0].beginPlaceAddress;
          data[i].endPlaceAddress = row.goodsRtnVos[0].endPlaceAddress;
          let beginPlaceArea;
          if (row.goodsRtnVos[0].beginPlaceArea) {
            if (Array.isArray(row.goodsRtnVos[0].beginPlaceArea)) {
              beginPlaceArea = row.goodsRtnVos[0].beginPlaceArea;
            } else {
              beginPlaceArea = row.goodsRtnVos[0].beginPlaceArea.split(",");
            }
            if (beginPlaceArea.length == 2) {
              data[i].city = beginPlaceArea[0];
              data[i].area = beginPlaceArea[1];
            } else {
              data[i].city = beginPlaceArea[1];
              data[i].area = beginPlaceArea[2];
            }
            data[i].province = beginPlaceArea[0];
            this.loadCity(data[i].province, i, 1, true);
            this.loadArea(data[i].province, data[i].city, i, 1, true);
          } else {
            data[i].province = "";
            data[i].city = "";
            data[i].area = "";
          }
          let endPlaceArea;
          if (row.goodsRtnVos[0].endPlaceArea) {
            if (Array.isArray(row.goodsRtnVos[0].endPlaceArea)) {
              endPlaceArea = row.goodsRtnVos[0].endPlaceArea;
            } else {
              endPlaceArea = row.goodsRtnVos[0].endPlaceArea.split(",");
            }
            if (endPlaceArea.length == 2) {
              data[i].endCity = endPlaceArea[0];
              data[i].endArea = endPlaceArea[1];
            } else {
              data[i].endCity = endPlaceArea[1];
              data[i].endArea = endPlaceArea[2];
            }
            data[i].endProvince = endPlaceArea[0];
            this.loadCity(data[i].endProvince, i, 2, true);
            this.loadArea(data[i].endProvince, data[i].endCity, i, 2, true);
          } else {
            data[i].endProvince = "";
            data[i].endCity = "";
            data[i].endArea = "";
          }
        } else {
          data[i].goodsType = null;
        }
        if (row.rule) {
          data[i].goodsRule = row.rule;
        } else {
          data[i].goodsRule = null;
        }
        if (row.unit) {
          data[i].goodsUnit = row.unit;
        } else {
          data[i].goodsUnit = null;
        }
        if (row.carShipNum) {
          data[i].carShipId = row.goodsRtnVos[0].carShipId;
          data[i].carShipNum = row.carShipNum;
        } else {
          data[i].carShipId = null;
          data[i].carShipNum = null;
        }
        if (row.transportationType) {
          data[i].logisticsType = row.transportationType;
        } else {
          data[i].logisticsType = null;
        }

        if (row.beginPlace) {
          data[i].beginPlace = row.beginPlace;
        } else {
          data[i].beginPlace = null;
        }
        if (row.endPlace) {
          data[i].endPlace = row.endPlace;
        } else {
          data[i].endPlace = null;
        }
        if (row.voyage) {
          data[i].voyage = row.voyage;
        } else {
          data[i].voyage = null;
        }
        if (row.deliveryPoints) {
          data[i].deliveryPlace = row.deliveryPoints;
        } else {
          data[i].deliveryPlace = null;
        }
        this.$refs.orderModal.close();
        this.orderVisible = false;
        this.clearV();
      },
      updateFooterEvent() {
        this.$refs.xTable.updateFooter();
      },
      footerMethod({columns, data}) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return "合计";
            }
            if (["counts", "realCount"].includes(column.property)) {
              return this.$utils.sum(data, column.property);
            }
            return null;
          })
        ];
      }
    }
  };
</script>

<style>
  .modal-container {
    position: relative;
    height: 100%;
  }

  .modal-footer {
    padding: 10px 0 0 0;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    position: absolute;
    bottom: 0;
  }

  .add-btn {
    width: 20px;
    height: 20px;
    color: #fff;
    line-height: 20px;
    background-color: #2d8cf0;
    border: none;
    border-radius: 0;
  }
</style>